import { hexToBytes } from '@ethereumjs/util';

export const encodeKeys = (
  ethereumPrivateKey: string,
  starkwarePrivateKey: string
) => {
  const ethKey = hexToBytes(ethereumPrivateKey);
  const starkKey = hexToBytes(starkwarePrivateKey);

  const message = new Uint8Array(ethKey.length + starkKey.length);
  message.set(ethKey);
  message.set(starkKey, ethKey.length);

  return message;
};
